import zozoFitRequester from "api/zozoFitRequester"

const paymentAPI = {
  getPlans(): Promise<any> {
    return zozoFitRequester.get("/v2/payment/products")
  },

  getUserPlan(): Promise<any> {
    return zozoFitRequester.get("/v2/users/plan")
  },
}

export default paymentAPI
